import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import Checkbox from '@components/common/checkbox/main';
import { get as getLabels } from '@api/v4/resources/labels';

function ScopeLabelSelection({ updateScope }) {
  const [scopeResources, updateScopeResources] = useState([]);
  const [selectedKeys, updateSelectedKeys] = useState([]);
  const [scopableSearch, updateScopableSearch] = useState('');
  const [allScopableSelected, updateAllSelected] = useState(false);


  useEffect(() => {
    getLabels().then((resources) => {
      updateScopeResources(resources);
    });
  }, []);

  const renderScopableSearch = () => {
    const hideCloseClass = scopableSearch === '' ? 'hide-close' : '';
    return (
      <div className="add-resource-search-container">
        <span className="icon bff-search" />
        <span
          className={`icon bff-close ${hideCloseClass}`}
          onClick={() => updateScopableSearch('')}
        />
        <input
          className="inputs add-resource-search"
          type="text"
          value={scopableSearch}
          onChange={(e) => { updateScopableSearch(e.target.value); }}
          placeholder="Search Labels"
        />
      </div>
    );
  };

  const handleActionableUpdates = (key) => {
    const selections = new Set(selectedKeys);
    if (selections.has(key)) {
      selections.delete(key);
    } else {
      selections.add(key);
    }
    updateSelectedKeys([...selections]);
    if (selections.size < 1) {
      updateScope(null);
    } else {
      updateScope({ label_keys: [...selections] });
    }
  };

  const formattedCheckboxes = () => {
    const sortedResources = [...scopeResources].sort((a, b) => {
      if (a.attributes.name.toUpperCase() > b.attributes.name.toUpperCase()) {
        return 1;
      }
      if (b.attributes.name.toUpperCase() > a.attributes.name.toUpperCase()) {
        return -1;
      }
      return 0;
    });
    const displayedActionables = [];

    for (let i = 0; i < sortedResources.length; i += 1) {
      const resource = sortedResources[i];
      const displayActionable = resource.attributes.name.toUpperCase().indexOf(scopableSearch.toUpperCase()) > -1;

      if (displayActionable) {
        displayedActionables.push(
          <div className="checkbox-container" key={i}>
            <Checkbox
              checked={selectedKeys.indexOf(resource.id) > -1}
              labelHtml={<h5> {resource.attributes.name} </h5>}
              size="sm"
              toggle={() => handleActionableUpdates(resource.id)}
            />
          </div>
        );
      }
    }

    return displayedActionables;
  };

  const handleSelectAllResources = (isSelected) => {
    if (isSelected) {
      const resourceKeys = [...scopeResources.map((resource) => resource.id)];
      updateSelectedKeys(resourceKeys);
      updateScope({ label_keys: resourceKeys });
    } else {
      updateSelectedKeys([]);
      updateScope(null);
    }
    updateAllSelected(isSelected);
  };

  const renderScopableList = () => {
    const selectAllCollectionsCheckbox = (
      <div className="checkbox-container" key="-1">
        <Checkbox
          size="sm"
          checked={allScopableSelected}
          labelHtml={<h5> {t('All')}</h5>}
          toggle={() => handleSelectAllResources(!allScopableSelected)}
        />
      </div>
    );

    const hideAllCheckbox = scopableSearch.length;
    const checkboxes = hideAllCheckbox
      ? [formattedCheckboxes()]
      : [selectAllCollectionsCheckbox, formattedCheckboxes()];

    return (
      <div className="resource-list-container fixed-height">
        { checkboxes }
      </div>
    );
  };

  return (
    <React.Fragment>
      <h3 className="resource-select-title">Select Labels</h3>
      {renderScopableSearch()}
      {renderScopableList()}
    </React.Fragment>
  );
}

ScopeLabelSelection.propTypes = {
  updateScope: PropTypes.func.isRequired
};

export default ScopeLabelSelection;
